(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-vr-editorial]').forEach(section => {
      if (section.dataset.vrReady) return;
      section.dataset.vrReady = 'true';
      const nav = section.querySelector('[data-vr-toc]');
      const body = section.querySelector('.blog-post-content rte-formatter');
      if (nav && body) {
        const headings = [...body.querySelectorAll('h2')];
        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = `${section.id}-heading-${index + 1}`;
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent;
          nav.append(link);
        });
        if (headings.length) nav.closest('aside').hidden = false;
      }
      const links = [...section.querySelectorAll('.vr-editorial__nav a[href^="#"]')];
      const targets = links.map(link => document.getElementById(link.hash.slice(1))).filter(Boolean);
      const activate = id => links.forEach(link => {
        if (link.hash === `#${id}`) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      links.forEach(link => link.addEventListener('click', () => {
        activate(link.hash.slice(1));
        const target = document.getElementById(link.hash.slice(1));
        if (target) {
          target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        }
      }));
      if (targets.length && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          const first = entries.find(entry => entry.isIntersecting);
          if (first) activate(first.target.id);
        }, { rootMargin: '-5% 0px -65% 0px', threshold: 0 });
        targets.forEach(target => observer.observe(target));
        section.vrObserver = observer;
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-vr-editorial]').forEach(section => section.vrObserver?.disconnect());
  });
  document.addEventListener('shopify:block:select', event => {
    const details = event.target.closest('details');
    if (details) details.open = true;
  });
})();
